import { SearchAction, SearchActionTypes } from '../../../../core/features/store/actions/search.actions';
import { AVAILABLE_SHIP_TOS, AvailableShipTosSearchParamsState } from '../sold-to-state';

export const initialState: AvailableShipTosSearchParamsState = {
  key: undefined,
  count: 0,
  page: 0,
  text: '',
  userUid: undefined,
  onlyConnected: false,
  soldTos: undefined,
};

export function reducer(state = initialState, action: SearchAction): AvailableShipTosSearchParamsState {
  if (action.searchType !== AVAILABLE_SHIP_TOS) {
    return state;
  }
  switch (action.type) {
    case SearchActionTypes.SearchAction:
      return action.searchParams;
    default:
      return state;
  }
}
